import { isAxiosError } from '@wkda/funnel-utils';
export function createApi(httpClient) {
  return {
    getPropertyById
  };
  function getPropertyById(id, propertyId) {
    return httpClient.get(`car-details/${id}/property/${propertyId}`).then(r => r.data).catch(error => {
      if (isAxiosError(error)) {
        if (error.response?.status === 404) {
          return null;
        }
        throw error;
      }
    });
  }
}